import { render, staticRenderFns } from "./AssetPriceSources.vue?vue&type=template&id=76e7cad4"
import script from "./AssetPriceSources.vue?vue&type=script&lang=js"
export * from "./AssetPriceSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports